import React, { useState, useEffect } from 'react';
import { useParams,useHistory } from "react-router-dom";
import toast from 'toasted-notes'
import 'toasted-notes/src/styles.css';
import CrudForm from "../../../crud/CrudForm"
import {paymenttypeService as service } from "../../../../services"
import { useTranslation } from 'react-i18next';


  const initElement =  {
    name : null,
};


export default function FormPayment() {
  const { t, i18n } = useTranslation();


  const estructureform =  [
      {
        type:"input",
        name: "code",
        col: 4,
        readonly:true,
        },
      {
        type:"input",
        name: "name",
        col: 4
       },
       {
         type:"input",
         name: "days",
         inputtype:"number",
         step:1,
         col: 4
        },
        {
          type:"checkbox",
          name: "remesa",
          col: 4
         },
   ];


  const recoveryElement = function(objectedit,element){


    objectedit['name']=element.name?element.name:"";

    return objectedit;
  }



  const isValid = function(object){
      if(!object['name']){
        return t("payment.error.name");
      }

      return null;
  }



  return (
    <CrudForm
        objectform = {{...initElement}}
        estructureform = {estructureform}
        i18n={"payment"}
        urledit={"/paymenttype/edit/"}
        urlCancel={"/paymenttype"}
        service = {service}
        recoveryElement = {recoveryElement}
        valid = {isValid}
      />

  );
}
